import script from "./UmbracoForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UmbracoForm.vue?vue&type=script&setup=true&lang=ts"

import "./UmbracoForm.vue?vue&type=style&index=0&id=4aaf6650&lang=scss"

const __exports__ = script;

export default __exports__